import CaptureForm from './components/CaptureForm'
import SavedItemsPanel from './components/SavedItemsPanel'
import { useAuth } from '../../hooks/useAuth'

function Dashboard() {
  const { user, isAuthenticated } = useAuth()

  return (
    <div style={{ display: 'grid', gap: '24px' }}>
      <header>
        <h1 style={{ fontSize: '2rem', marginBottom: '12px' }}>FTS Library dashboard</h1>
        <p style={{ color: '#4f5b66', maxWidth: '60ch' }}>
          Save links from any device, let the summarisation pipeline do the heavy lifting, and return when you&apos;re ready to read.
        </p>
        <p style={{ marginTop: '8px', fontSize: '0.9rem', color: '#4f5b66' }}>
          Need raw payload details? Open the <a href='/share-complete' style={{ color: '#0b1f33' }}>share inbox</a> to inspect
          messages from the Android share target or Chrome extension.
        </p>
        {isAuthenticated ? (
          <p style={{ marginTop: '12px', color: '#1b7f5f', fontWeight: 600 }}>
            Welcome back{user?.name ? `, ${user.name}` : ''}! New saves appear below as soon as they&apos;re processed.
          </p>
        ) : null}
      </header>

      <CaptureForm />

      <SavedItemsPanel />
    </div>
  )
}

export default Dashboard
